const order = {
  'orderList.title': '订单列表',
  'orderList.api.error.getOrderList': '获取订单列表失败',
};

export default order;
